<template>
  <div>
    <el-header width="500px" height="100px">
      <el-menu
        default-active="1"
        class="el-menu-demo"
        mode="horizontal">
        <el-menu-item index="1" @click="addNews">
          <i class="el-icon-circle-plus-outline"></i>
          <span slot="title">添加新闻</span>
        </el-menu-item>
        <el-menu-item index="2" @click="manageNews">
          <i class="el-icon-s-fold"></i>
          <span slot="title">管理新闻</span>
        </el-menu-item>
      </el-menu>
    </el-header>
    <el-main class="main">
      <router-view />
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'NewsManage',
  mounted() {
    this.$router.push({'name': 'newsAdd'})
  },
  methods: {
    addNews () {
      this.$router.push({'name': 'newsAdd'})
    },
    manageNews () {
      this.$router.push({'name': 'manageNews'})
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/news_add/NewsManage.vue